import React from "react";
import { Button } from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { useContactFormDialog } from "@/hooks/useContactFormDialog";

export const ContactButton: React.FC = () => {
  const { openContactForm } = useContactFormDialog();

  return (
    <Button
      variant="text"
      startIcon={<MailOutlineIcon />}
      onClick={openContactForm}
      sx={{ color: "darkgray.main", fontWeight: 400 }}
    >
      お問い合わせ
    </Button>
  );
};
